import {FileRepository} from '@api/repositories/FileRepository';
import { getFileUrl } from "@common/FileUrlHelper";
import { AppercodeFile } from "@api/models/File";
import { downloadBlob } from "@common/BlobDownloadHelper";

export class FileService {

    constructor(
        private backend: string,
        private fileRepository: FileRepository
    ) {
    }

    async downloadFile(file: AppercodeFile) {
        if (
            file &&
            Object.prototype.hasOwnProperty.call(file, 'id') &&
            Object.prototype.hasOwnProperty.call(file, 'contentType')
        ) {
            const fileId = file?.id;
            const fileContentType = file?.contentType;
            if (fileId && fileContentType) {
                const url = getFileUrl(this.backend, fileId, file.name);
                const response = await this.fileRepository.getFile(url);
                const blob = new Blob([response.data], { type: fileContentType });

                downloadBlob(blob, file.name);
            }
        }
    }
}
